"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var detectLogout = function detectLogout() {
  if (typeof window === 'undefined') return;
  var userId;

  try {
    userId = "".concat((0, _insidedDataStorage.getInsidedData)('user').userid);
  } catch (_unused) {
    return;
  }

  var storageKey = 'logout-event';
  window.localStorage.setItem(storageKey, userId);
  window.addEventListener('storage', function (event) {
    if (event.key === storageKey && event.newValue !== event.oldValue) {
      window.location.reload();
    }
  }); // this event is triggered when using a back button
  // https://web.dev/bfcache/#update-stale-or-sensitive-data-after-bfcache-restore

  window.addEventListener('pageshow', function (event) {
    if (event.persisted && window.localStorage.getItem(storageKey) !== userId) {
      window.location.reload();
    }
  });
};

var _default = detectLogout;
exports.default = _default;